<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Новости"
    >
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="newsData"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #top>
          <v-toolbar flat>
            <router-link :to="{ name: 'news-edit'}" target="_blank">
              Новая Новость
            </router-link>
          </v-toolbar>
        </template>
        <template #item.publishAt="{ item }">
          {{ new Date(item.publishAt * 1000).toLocaleString("ru-RU") }}
        </template>
        <template #item.actions="{ item }">
          <router-link :to="{ name: 'news-view-id', params: { id: item.id }}" target="_blank">
            <v-icon v-bind="attrs" small class="mr-2" v-on="on">
              mdi-eye
            </v-icon>
          </router-link>
          <router-link :to="{ name: 'news-edit-id', params: { id: item.id }}" target="_blank">
            <v-icon v-bind="attrs" small class="mr-2" v-on="on">
              mdi-pencil
            </v-icon>
          </router-link>
          <v-dialog
            transition="dialog-bottom-transition"
            width="500"
            :value="deleteDialog === item.id"
            @input="toggleDeleteDialog($event, item.id)"
          >
            <template #activator="{ on, attrs }">
              <v-tooltip top>
                <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                  <span v-bind="tooltipAttrs" v-on="tooltipActions">
                    <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                      mdi-delete
                    </v-icon>
                  </span>
                </template>
                Удалить
              </v-tooltip>
            </template>
            <v-card>
              <v-toolbar color="primary" dark class="text-center mb-6">
                Подтвердите Действие
              </v-toolbar>
              <v-card-text>
                Вы точно хотите удалить новость "{{ item.name }}"?
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn color="tertiary" dark @click="deleteDialog = null">
                  Отменить
                </v-btn>
                <v-btn color="primary" @click="deleteItem(item.id)">
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { news } from '@/graphql/news'
import { articlesPageHelpers, deleteArticle } from '@/graphql/articles'
import { startCase } from 'lodash-es'

export default {
  name: 'Articles',
  layout: 'dashboard',
  apollo: {
    news: {
      query: news,
      variables () {
        return this.getArticlesQueryVariables()
      },
      update (data) {
        return data.news.data
      },
      result ({ data }) {
        this.totalCount = data.news.totalCount
      }
    },
    filters: {
      query: articlesPageHelpers,
      update (data) {
        return Object.fromEntries(
          Object.entries(data).map(([key, value]) =>
            [
              key,
              Object.prototype.hasOwnProperty.call(value, 'data') ? value.data : value
            ]
          )
        )
      }
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      totalCount: 0,
      selectedCategory: null,
      deleteDialog: false,
      headers: [
        'id',
        ['name', 'Заголовок'],
        ['title', 'Заголовок для поиска'],
        ['description', 'Описание'],
        'url',
        ['status', 'Статус'],
        ['publishAt', 'Дата Публикации'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          })
    }
  },
  computed: {
    newsData () {
      return this.news ?? []
    }
  },
  methods: {
    getArticlesQueryVariables () {
      return {
        limit: this.options.itemsPerPage,
        offset: this.options.itemsPerPage * (this.options.page - 1)
      }
    },
    toggleDeleteDialog (value, id) {
      this.deleteDialog = value
        ? id
        : null
    },
    deleteItem (id) {
      this.deleteDialog = null

      this.$apollo.mutate({
        mutation: deleteArticle,
        variables: { id: Number(id) },
        update: (store) => {
          const queryVariables = this.getArticlesQueryVariables()
          const query = {
            query: news,
            variables: queryVariables
          }

          const cache = store.readQuery(query)
          cache.news.totalCount -= 1

          if (this.news.totalCount - (this.options.itemsPerPage * this.options.page) === 1) {
            this.options.page -= 1
          } else {
            const index = cache.news.data.findIndex(article => article.id === id)
            if (index >= 0) {
              cache.news.data.splice(index, 1)
            }

            this.$apollo.queries.news.fetchMore({
              variables: {
                ...queryVariables,
                limit: 1,
                offset: this.options.page * this.options.itemsPerPage - 1
              },
              updateQuery: (cache, { fetchMoreResult }) => {
                return {
                  news: {
                    __typename: cache.articles.__typename,
                    data: [...cache.articles.data, ...fetchMoreResult.articles.data],
                    totalCount: fetchMoreResult.articles.totalCount
                  }
                }
              }
            })
          }

          store.writeQuery({ ...query, data: cache })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
